import { useEffect, useRef } from 'react';
import cn from 'classnames';
import IconCheck from '@creditflowresearch/uilib/Icon/IconCheck';
import { MONTH_NAMES_FULL } from './constants';

import styles from './datePickerHeader.module.scss';

interface IMonthOverlayProps {
  selectedMonth: number,
  currentYear: number,
  minDate?: Date | null,
  maxDate?: Date | null,
  onSelect: (month: number) => void,
}

const MonthOverlay = ({ selectedMonth, currentYear, minDate, maxDate, onSelect }: IMonthOverlayProps) => {
  const selectedRef = useRef<HTMLButtonElement>(null);
  const minMonth = (minDate && currentYear === minDate.getFullYear()) ? minDate.getMonth() : 0;
  const maxMonth = (maxDate && currentYear === maxDate.getFullYear()) ? maxDate.getMonth() : 11;

  useEffect(() => {
    selectedRef.current?.scrollIntoView({ block: 'center' });
  }, []);

  return (
    <div className={ styles.overlay }>
      { MONTH_NAMES_FULL.map((name, index) => {
        const isDisabled = index < minMonth || index > maxMonth;
        const isSelected = index === selectedMonth;

        return (
          <button
            key={ name }
            ref={ isSelected ? selectedRef : undefined }
            type="button"
            className={ cn(styles.overlayItem, {
              [styles.selected]: isSelected,
              [styles.disabled]: isDisabled,
            }) }
            onClick={ () => onSelect(index) }
            disabled={ isDisabled }
          >
            <span>{ name }</span>
            { isSelected && <IconCheck className={ styles.checkmark } /> }
          </button>
        );
      }) }
    </div>
  );
};

export default MonthOverlay;
